/* pantallas-alumno (B): EL CHIP VERDE Y EL CHIP DE DIFICULTAD.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   - Chip verde (piezas nuevas de la parte 1): fondo #0F1F16, borde #1F4A2E, texto #4ADE80. Para
     "Recommended", "easy", "known", "Known", "Completed" y "Best". Misma forma que el chip de estado
     del Panel (22 px, radio completo, 12 px seminegrita, icono de 12).
   - Chip de dificultad: 22 px, en minusculas como hoy (el texto lo pone quien lo usa): "easy" verde,
     "medium" naranja suave y "hard" rojo, los dos del chip del Panel (se importa, no se copia). */
import React from 'react';
import ChipDeEstado from '../panel/ChipDeEstado';

export const COLORES_CHIP_VERDE = Object.freeze({ fondo: '#0F1F16', borde: '#1F4A2E', texto: '#4ADE80' });

export function ChipVerde({ children, icono: Icono, titulo, testid, className = '' }) {
  const c = COLORES_CHIP_VERDE;
  return (
    <span
      className={`inline-flex items-center gap-1 h-[22px] px-2 rounded-full border text-[12px] leading-none font-semibold whitespace-nowrap ${className}`.trim()}
      style={{ backgroundColor: c.fondo, borderColor: c.borde, color: c.texto }}
      data-testid={testid}
      data-tono="verde"
      title={titulo}
    >
      {Icono ? <Icono className="w-3 h-3 shrink-0" aria-hidden="true" /> : null}
      <span className="truncate">{children}</span>
    </span>
  );
}

const TONO_POR_NIVEL = { medium: 'naranja', hard: 'rojo' };

export function ChipDeDificultad({ nivel, children, testid, className = '' }) {
  const n = typeof nivel === 'string' ? nivel.trim().toLowerCase() : '';
  if (n === 'easy') return <ChipVerde testid={testid} className={className}>{children}</ChipVerde>;
  return <ChipDeEstado tono={TONO_POR_NIVEL[n] || 'neutro'} testid={testid} className={className}>{children}</ChipDeEstado>;
}
